import { Helmet } from 'react-helmet';
import Artworks from '../components/Artworks'
import Empty1 from '../components/Empty1'
import Hero from '../components/Hero'

import { useGlobalState } from '../store'

const Home = () => {
  const [auctions] = useGlobalState('auctions') 
  return (
 <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Sunshine NFT Market - 首頁</title>
                <meta name="description" content="在Sunshine NFT Market上發現和交易稀有且獨特的可以影音式、圖像式來鑄造非同質化代幣（NFT）。購買、出售和展示您的影音式、圖像式、數字藝術作品和收藏品。" />

            </Helmet>
            {/* 網頁內容 */}
            


          <div className="flex">


              <div className="flex-1">
                  <Hero />
                  {auctions.length > 0 ? <Artworks auctions={auctions} /> : <Empty1 />}
              </div>
          </div>


 </>
  )
}

export default Home

